import  './index.less';
import React, { Component } from 'react';
class Banner extends Component{
    state = {
        isios:false
    }
    componentDidMount(){
        // 判断是否为移动端
        if ((navigator.userAgent.match(/(iPhone|iPod|Android|ios|iPad)/i))) {
            this.setState({
                isios : true
            })
        }
    }
    render(){
        return(
            <div className="banner">
                {
                    this.state.isios
                    ?
                    <img src="//b1.qikucdn.com/dfsj_imgs/zhuanti/luyin/static/images/new_webbanner.jpg" alt=""/>
                    :
                    <img src="//b1.qikucdn.com/dfsj_imgs/zhuanti/luyin/static/images/new_webbanner_wap.jpg" alt=""/>
                } 
                <div className="banner-con">
                    <h1>好奇君说</h1>
                    <p><span className="banner-con-icon-left"><i></i></span> 听，是你的2018<span className="banner-con-icon-right"><i></i></span></p>
                    <span>2018.12.29-2019.01.14</span>
                </div>
            </div>
        )
    }
}
export default Banner;


// WEBPACK FOOTER //
// ./src/component/banner/index.jsx